import * as Sentry from "@sentry/react";
import { environments, getCurrentEnvironment } from "@/utils";
 
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_SECRET;
  const appVersion = import.meta.env.VITE_APP_VERSION || "0.0.1";
  const currentEnv = getCurrentEnvironment();

  // Skip Sentry in development mode
  if (currentEnv === environments.DEVELOPMENT) {
    if (import.meta.env.DEV) {
      console.log("[Sentry] Skipped in development environment");
    }
    return;
  }

  // If DSN missing → do not initialize
  if (!dsn) {
    console.warn("[Sentry] No DSN provided. Skipping initialization.");
    return;
  }

  Sentry.init({
    dsn,
    environment: currentEnv,
    release: `kuick-frontend@${appVersion}`,
    
    // Integrations
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    // Performance monitoring
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      "https://staging.react.kuick.com/",
      "https://prod.react.kuick.com/",
      "http://dineorder.com",
      "http://www.dineorder.com",
      "https://kuick.com/",
      "https://www.kuick.com/",
    ],

    // Session replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

  console.log(`[Sentry] Initialized for ${currentEnv} environment`);
}
